import { gql } from './apollo';

export const GET_LATEST_CARD_ON_HAND = gql`
    query ($card_id: MultiTypeInput!) {
        table(
            name: "gc_card_inventory_updates"
            columns: ["new_balance"]
            filter: [{ left: "card_id", right: $card_id, expression: "=" }]
            orderBy: "updated_date"
            orderByDirection: DESC
            limit: 1
        )
    }
`;

export const GET_CARD_UPDATES_FOR_CARD = gql`
    query ($card_id: MultiTypeInput!) {
        table(
            name: "gc_card_inventory_updates"
            filter: [{ left: "card_id", right: $card_id, expression: "=" }]
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "updated_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "updated_by"
                    limit: 1
                }
            ]
            orderBy: "updated_date"
            orderByDirection: DESC
            limit: 100
        )
    }
`;

export const CREATE_CARD_UPDATE = gql`
    mutation (
        $card_id: MultiTypeInput
        $property__c_id: MultiTypeInput
        $new_balance: MultiTypeInput
        $num_distributed: MultiTypeInput
        $num_destroyed: MultiTypeInput
        $num_transferred: MultiTypeInput
        $num_lost: MultiTypeInput
        $given_to: MultiTypeInput
        $notes: MultiTypeInput
        $updated_by: MultiTypeInput
        $updated_date: MultiTypeInput
    ) {
        createRow(
            table: "gc_card_inventory_updates"
            values: [
                { property: "card_id", value: $card_id }
                { property: "property__c_id", value: $property__c_id }
                { property: "new_balance", value: $new_balance }
                { property: "num_distributed", value: $num_distributed }
                { property: "num_destroyed", value: $num_destroyed }
                { property: "num_transferred", value: $num_transferred }
                { property: "num_lost", value: $num_lost }
                { property: "given_to", value: $given_to }
                { property: "notes", value: $notes }
                { property: "updated_by", value: $updated_by }
                { property: "updated_date", value: $updated_date }
            ]
        )
    }
`;

export const UPDATE_CARD_UPDATE = gql`
    mutation ($id: String!, $new_balance: MultiTypeInput) {
        updateRow(
            table: "gc_card_inventory_updates"
            id: $id
            values: [{ property: "new_balance", value: $new_balance }]
        )
    }
`;
